import { isEmpty, isFalsy, isTruthy } from '../utils/bits'
import { isEqual, constant, isString, isFunction } from 'lodash-es'

import debugFields from '../utils/debug-fields'
import isBrightColor from '../utils/is-bright-color'

import DROP_MARKER from './gallery-properties.flow.drop-marker'

import { LOW_OPACITY } from '../utils/shared-constants'

export function Equal(getKey, getCmp) {
  return debugFields(equal, {
    _getKey: getKey,
    _getCmp: getCmp
  })

  function equal(rawVal, calcProp) {
    const keyVal = isFunction(getKey)
      ? getKey(rawVal, calcProp)
      : calcProp(getKey)
    const cmpVal = isFunction(getCmp)
      ? getCmp(rawVal, calcProp)
      : getCmp
    return isEqual(keyVal, cmpVal)
  }
}

export function Replace(getReplace) {
  return debugFields(replace, {
    _getReplace: getReplace
  })

  function replace(rawVal, calcProp) {
    const replaceVal = isFunction(getReplace)
      ? getReplace(rawVal, calcProp)
      : getReplace

    if (isEmpty(replaceVal)) {
      return null
    } else {
      return replaceVal
    }
  }
}

export function ColorSchema(getBaseClr, getBaseOpacity, brightVal, darkVal) {
  if (arguments.length === 3) {
    darkVal = brightVal
    brightVal = getBaseOpacity
    getBaseOpacity = constant(1)
  }

  return debugFields(colorSchema, {
    _getBaseClr: getBaseClr,
    _getBaseOpacity: getBaseOpacity,
    _brightVal: brightVal,
    _darkVal: darkVal
  })

  function colorSchema(rawVal, calcProp) {
    const baseClr = isFunction(getBaseClr) ? getBaseClr(rawVal, calcProp) : calcProp(getBaseClr)
    const baseOpacity = isFunction(getBaseOpacity) ? getBaseOpacity(rawVal, calcProp) : calcProp(getBaseOpacity)

    if (baseOpacity < LOW_OPACITY) {
      return darkVal
    } else if (isBrightColor(baseClr)) {
      return darkVal
    } else {
      return brightVal
    }
  }
}

export function TrueIf(...getConds) {
  return CondIterator(getConds, true, isTruthy)
}

export function FalseIf(...getConds) {
  return CondIterator(getConds, false, isTruthy)
}

export function DropIf(...getConds) {
  return CondIterator(getConds, DROP_MARKER, isTruthy)
}

export function ValueIf(getCond, getAlt) {
  return CondIterator([getCond], getAlt, isTruthy)
}

export function TrueUnless(...getConds) {
  return CondIterator(getConds, true, isFalsy)
}

export function FalseUnless(...getConds) {
  return CondIterator(getConds, false, isFalsy)
}

export function DropUnless(...getConds) {
  return CondIterator(getConds, DROP_MARKER, isFalsy)
}

export function ValueUnless(getCond, getAlt) {
  return CondIterator([getCond], getAlt, isFalsy)
}

export function CondIterator(getConds, getAlt, checkCond) {
  return debugFields(cndIterator, {
    _getConds: getConds,
    _getAlt: getAlt,
    _checkCond: checkCond
  })

  function cndIterator(rawVal, calcProp) {
    for (const getCond of getConds) {
      let cndVal
      if (isString(getCond)) {
        cndVal = calcProp(getCond)
      } else if (isFunction(getCond)) {
        cndVal = getCond(rawVal, calcProp)
      } else {
        cndVal = getCond
      }

      if (checkCond(cndVal)) {
        const altVal = isFunction(getAlt)
          ? getAlt(rawVal, calcProp)
          : getAlt

        if (isEmpty(altVal)) {
          return null
        } else {
          return altVal
        }
      }
    }

    return null
  }
}
